import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Image from '../util/Image';

import styles from './Curator.css';

import { PROFILE_IMAGE_PREVIEW_DIMS } from '../../lib/imgix';

class Curator extends PureComponent {
  static propTypes = {
    curator: PropTypes.object.isRequired,
  };

  render() {
    const { curator } = this.props;

    return (
      <div className={styles.container}>
        <Image
          src={curator.imageUrl}
          className={styles.avatar}
          width={PROFILE_IMAGE_PREVIEW_DIMS.w}
          height={PROFILE_IMAGE_PREVIEW_DIMS.h}
          alt=""
        />
        <span className={styles.details}>
          <span className={styles.name}>{curator.name}</span>
          <div className={styles.summary}>{curator.summary}</div>
        </span>
      </div>
    );
  }
}

export default Curator;
